// extracted by mini-css-extract-plugin
export default {"wrapper":"Label_wrapper__IfsHs","description":"Label_description__nzGvJ","tooltip":"Label_tooltip__J2vUv","icon":"Label_icon__e2xp9"};